import React from 'react';

const Loader = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary-color border-solid"></div>
    </div>
  );
};

export default Loader;
    